import { Percent } from './Percent';

export default Percent;
